module.exports = __webpack_public_path__ + "img/milestone__1978.7bc0421f.jpg";